import api from '@pray/shared/utils/api';

export type ImportFileKind = 'TRACKER_CSV' | 'QBO_INVOICE_LIST' | 'PAYMENTS';

// The QBO/XLSX subset of ImportFileKind — what the QBO preview/commit arms
// can actually carry. Pinned explicitly to 'QBO_INVOICE_LIST': PAYMENTS is a
// distinct arm (its own preview/commit shapes), so an Exclude<…, 'TRACKER_CSV'>
// would wrongly widen this to include PAYMENTS.
export type QboImportFileKind = 'QBO_INVOICE_LIST';

// The Payments arm's file_kind. Payments accept both .csv and .xlsx but have
// their own preview/commit shapes (pending_payments / payments_applied).
export type PaymentsImportFileKind = 'PAYMENTS';

export type ImportColumnMap = Readonly<Record<string, string | null>>;

export type GetImportDefaultsResponse = {
  file_kind: ImportFileKind;
  default_map: ImportColumnMap;
  target_fields: readonly string[];
  required_fields: readonly string[];
};

export const getImportDefaults = async (
  fileKind: ImportFileKind = 'TRACKER_CSV'
): Promise<GetImportDefaultsResponse> => {
  const url = '/web/studio/superfunnel/import/defaults';
  const response = await api.executeGetRequest(url, { file_kind: fileKind });
  return (response.data as { data: GetImportDefaultsResponse }).data;
};
